import { takeLatest } from 'redux-saga/effects'
import { put, select } from '@redux-saga/core/effects'
import { SignaturesConstants } from '../store/signatures.constants'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import { ISignaturesState } from '../store/signatures.types'
import { saveTempSignature, setSelectedSignatureType, setSignatureSection } from '../store/signatures.actions'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { ISignatureOptionsState } from '../../options/store/options.types'

export function* loadSignatureData() {
  const signatureState: ISignaturesState = yield select(getSignaturesSelector)
  const signatureOptionState: ISignatureOptionsState = yield select(getSignatureOptionsSelector)
  const { sectionOptions } = signatureOptionState
  const { currentSelectedChip } = signatureState
  if (currentSelectedChip != null) {
    const { option, name, signatureBase64 } = currentSelectedChip
    const currentSection = sectionOptions.find((optionObj) => optionObj.name === name)
    yield put(setSignatureSection(currentSection))
    yield put(setSelectedSignatureType(option))
    yield put(saveTempSignature(signatureBase64))
  }
}

export function* loadSignatureDataSaga() {
  yield takeLatest([SignaturesConstants.LOAD_SIGNATURE_DATA], loadSignatureData)
}
